import { PostFormRequest, PutFormRequest } from "../../services/ApiClientService"
import { useError } from "../../context/useErrorContext"
import { useLoad } from "../../context/useLoadContext"
import { useGetPromotions } from "./useGetPromotions"
import { Promotions } from "../../Objects/Promotion/Promotions"
import { API_ROUTES } from "../../configuration/RoutesApi"
import { useTranslation } from "react-i18next"

export const useSavePromotions = () => {
  const { t } = useTranslation("general")

  const { enableLoad, disableLoad } = useLoad()

  const { setError } = useError()

  const { handleGetPromotions } = useGetPromotions()

  const handleSavesPromotions = async (promotionChange: Promotions, onSuccess: any) => {
    try {
      enableLoad()

      var response = null

      if (promotionChange.id !== -1) {
        response = await PutFormRequest(`${API_ROUTES.PROMOTION.PUT}/${promotionChange.id}`, promotionChange.toJSON())
      } else {
        response = await PostFormRequest(API_ROUTES.PROMOTION.CREATE, promotionChange.toJSON())
      }

      if (response.success) {
        await handleGetPromotions(onSuccess)

        return
      }

      throw new Error(response.message)
    } catch (e: any) {
      const message = e instanceof Error ? e.message : t("label_unknown_error_description")
      setError(t("label_title_erro"), message)
    } finally {
      disableLoad()
    }
  }

  return {
    handleSavesPromotions,
  }
}
